var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDeleteRedOutlined = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M14.1032 6.89014C14.1032 6.89014 13.6507 12.5026 13.3882 14.8668C13.2632 15.996 12.5657 16.6576 11.4232 16.6785C9.24901 16.7176 7.07234 16.7201 4.89901 16.6743C3.79984 16.6518 3.11401 15.9818 2.99151 14.8726C2.72734 12.4876 2.27734 6.89014 2.27734 6.89014",
    stroke: "#DC2804",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M15.2567 4.19963H1.125",
    stroke: "#DC2804",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M12.5335 4.19974C11.8793 4.19974 11.316 3.73724 11.1877 3.0964L10.9852 2.08307C10.8602 1.61557 10.4368 1.29224 9.95432 1.29224H6.42682C5.94432 1.29224 5.52099 1.61557 5.39599 2.08307L5.19349 3.0964C5.06516 3.73724 4.50182 4.19974 3.84766 4.19974",
    stroke: "#DC2804",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteRedOutlined, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DeleteRedOutlined.313eca7f.svg";
export { ForwardRef as ReactComponent };